import React, { useState, useEffect } from 'react';
import CenterModal from '../../molecules/Modal/CenterModal';
import { MappingContacts } from '../CreateCompaign/CreateCompaign.styles';
import UploadLeads from './UploadLeads';
import DataMaping from './DataMaping';
import ImportJobsLeadsData from './ImportJobsLeadsData';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';

const ImportLeadsModal = ({ open, setOpen, onSuccess }) => {
    const [addLeadsDataTab, setAddLeadsDataTab] = useState('leads');
    const [data, setData] = useState(null);
    const [csvInfo, setCsvInfo] = useState(null);
    const [activeTab, setActiveTab] = useState('csv');
    const { refetch } = useContextHook(AuthContext, v => ({
        refetch: v.refetch,
    }));

    // Reset state when modal opens
    useEffect(() => {
        if (open) {
            setAddLeadsDataTab('leads');
            setData(null);
            setCsvInfo(null);
            setActiveTab('csv');
        }
    }, [open]);

    const handleSuccess = () => {
        onSuccess?.();
        refetch();
        setOpen(false);
    };

    const handleClose = () => {
        // Reset state when modal closes
        setAddLeadsDataTab('leads');
        setData(null);
        setCsvInfo(null);
        setActiveTab('csv');
    };

    const closeModal = () => {
        setOpen(false);
    };

    return (
        <CenterModal open={open} setOpen={setOpen} onClose={handleClose} width={975} noHead padding="0">
            <MappingContacts>
                {activeTab === 'csv' && (
                    <div className="tab-btns">
                        <span className={`btn ${addLeadsDataTab === 'leads' ? 'active' : ''}`}>Upload Leads</span>
                        <span className={`btn ${addLeadsDataTab === 'mapping' ? 'active' : ''}`}>Data Mapping</span>
                        <span className={`btn ${addLeadsDataTab === 'leadsData' ? 'active' : ''}`}>Summary</span>
                    </div>
                )}
                <div className="edit-content-wrap">
                    {addLeadsDataTab === 'leads' ? (
                        <UploadLeads
                            setData={setData}
                            addLeadsDataTab={addLeadsDataTab}
                            setAddLeadsDataTab={setAddLeadsDataTab}
                            setOpenLeadsModal={closeModal}
                            setCsvInfo={setCsvInfo}
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                    ) : addLeadsDataTab === 'mapping' ? (
                        <DataMaping
                            setData={setData}
                            data={data}
                            setAddLeadsDataTab={setAddLeadsDataTab}
                            setOpenLeadsModal={closeModal}
                            setCsvInfo={setCsvInfo}
                            domains_data={data?.step1?.domains_data}
                        />
                    ) : (
                        addLeadsDataTab === 'leadsData' && (
                            <ImportJobsLeadsData
                                data={data}
                                addLeadsDataTab={addLeadsDataTab}
                                setAddLeadsDataTab={setAddLeadsDataTab}
                                setOpenLeadsModal={closeModal}
                                onSuccess={handleSuccess}
                                csvInfo={csvInfo}
                            />
                        )
                    )}
                </div>
            </MappingContacts>
        </CenterModal>
    );
};

export default ImportLeadsModal;

